import { createAction, props } from '@ngrx/store';

export const loadCutOffDayForChange = createAction('[CutOffDay] Load CutOffDayForChange', props<{ request: { businessId: string } }>());

export const loadCutOffDayForChangeSuccess = createAction('[CutOffDay] Load CutOffDayForChange Success', props<{ response: string }>());

export const loadCutOffDayForChangeFailure = createAction('[CutOffDay] Load CutOffDayForChange Failure', props<{ error: Error | any }>());
